import { Directive, ElementRef, EventEmitter, Input, NgZone, OnDestroy, Output } from '@angular/core';

@Directive({
  selector: '[cxInViewport]',
  standalone: true,
})
export class CxInViewportDirective implements OnDestroy {
  @Input() rootMargin = '100px';
  @Input() threshold: number | number[] = 0.1;
  @Input() once = true;

  @Output() visibleChange = new EventEmitter<boolean>();

  private observer?: IntersectionObserver;

  constructor(
    private el: ElementRef,
    private zone: NgZone,
  ) {
    if (typeof IntersectionObserver === 'undefined') {
      this.zone.run(() => this.visibleChange.emit(true));
      return;
    }

    this.observer = new IntersectionObserver(
      entries => {
        const entry = entries[0];
        this.zone.run(() => {
          if (entry.isIntersecting) {
            this.visibleChange.emit(true);
            if (this.once) this.disconnect();
          } else {
            this.visibleChange.emit(false);
          }
        });
      },
      { root: null, rootMargin: this.rootMargin, threshold: this.threshold },
    );

    this.observer.observe(this.el.nativeElement);
  }

  private disconnect() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = undefined;
    }
  }

  ngOnDestroy(): void {
    this.disconnect();
  }
}
